import { Link } from 'react-router-dom';

export default function PartenariatsImpactPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-orange-50 to-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <div className="inline-block">
              <span className="text-sm font-semibold tracking-wider text-orange-500 uppercase">Ensemble, plus forts</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight font-serif">
              Partenariats &amp; Impact social
            </h1>
            
            <p className="text-xl text-slate-600 leading-relaxed">
              PULSAR FC développe des partenariats stratégiques avec les acteurs publics, associatifs et privés pour maximiser son impact territorial et construire une société plus inclusive.
            </p>
          </div>
        </div>
      </section>

      {/* Notre Approche Partenariale */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif mb-4">Une logique de coopération</h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                Nous croyons en la force du collectif et en la nécessité de travailler ensemble pour répondre aux enjeux sociaux de notre territoire.
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center">
                  <i className="ri-government-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">Partenaires publics</h3>
                <p className="text-slate-600 leading-relaxed">
                  Collectivités territoriales, services de l'État, Pôle emploi, CAF, missions locales... Nous collaborons avec les institutions pour déployer des actions d'intérêt général.
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center">
                  <i className="ri-community-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">Réseau associatif</h3>
                <p className="text-slate-600 leading-relaxed">
                  Associations locales, centres sociaux, structures d'insertion... Nous travaillons en réseau pour offrir un accompagnement global et coordonné.
                </p>
              </div>
              
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center">
                  <i className="ri-building-2-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">Entreprises engagées</h3>
                <p className="text-slate-600 leading-relaxed">
                  Entreprises privées engagées dans la RSE, structures d'insertion par l'activité économique... Nous facilitons l'insertion professionnelle de nos bénéficiaires.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Social */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold font-serif mb-4">Notre impact social</h2>
              <p className="text-xl text-slate-300 max-w-3xl mx-auto">
                Des résultats concrets qui témoignent de l'efficacité de notre action et de l'engagement de nos partenaires
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4">
                  <i className="ri-user-heart-line text-4xl text-orange-500"></i>
                </div>
                <div className="text-6xl font-light">500+</div>
                <div className="text-slate-400 text-lg">Personnes accompagnées chaque année</div>
              </div>
              
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-4xl text-orange-500"></i>
                </div>
                <div className="text-6xl font-light">1200+</div>
                <div className="text-slate-400 text-lg">Heures de formation dispensées</div>
              </div>
              
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4">
                  <i className="ri-briefcase-line text-4xl text-orange-500"></i>
                </div>
                <div className="text-6xl font-light">65%</div>
                <div className="text-slate-400 text-lg">Taux d'insertion professionnelle</div>
              </div>
              
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4">
                  <i className="ri-team-line text-4xl text-orange-500"></i>
                </div>
                <div className="text-6xl font-light">85%</div>
                <div className="text-slate-400 text-lg">Taux de satisfaction des bénéficiaires</div>
              </div>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-800 rounded-3xl p-8 space-y-4">
                <div className="text-4xl font-bold text-orange-500">25+</div>
                <h4 className="text-xl font-bold">Partenaires institutionnels</h4>
                <p className="text-slate-300">Collectivités, services de l'État, organismes publics</p>
              </div>
              
              <div className="bg-slate-800 rounded-3xl p-8 space-y-4">
                <div className="text-4xl font-bold text-orange-500">40+</div>
                <h4 className="text-xl font-bold">Entreprises partenaires</h4>
                <p className="text-slate-300">Employeurs engagés dans l'insertion professionnelle</p>
              </div>
              
              <div className="bg-slate-800 rounded-3xl p-8 space-y-4">
                <div className="text-4xl font-bold text-orange-500">15+</div>
                <h4 className="text-xl font-bold">Associations partenaires</h4>
                <p className="text-slate-300">Réseau associatif local et national</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Partenaires */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif mb-4">Ils nous font confiance</h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                Nos partenaires institutionnels, associatifs et privés qui soutiennent notre mission
              </p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
              {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                <div key={item} className="bg-white rounded-2xl p-8 flex items-center justify-center hover:shadow-lg transition-all duration-300 h-32">
                  <div className="text-slate-400 text-center">
                    <i className="ri-building-line text-4xl mb-2"></i>
                    <p className="text-sm font-semibold">Partenaire {item}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="text-center">
              <p className="text-slate-600 text-lg mb-6">
                Vous souhaitez devenir partenaire de PULSAR FC ?
              </p>
              <Link 
                to="/contact" 
                className="inline-block px-12 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif mb-4">Témoignages</h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                La parole à nos bénéficiaires et partenaires
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="flex gap-1 text-orange-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <p className="text-slate-700 leading-relaxed italic">
                  "Grâce à PULSAR FC, j'ai pu apprendre le français et retrouver un emploi. L'équipe est très professionnelle et bienveillante. Je recommande vivement leurs formations."
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
                    AM
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">Amina M.</div>
                    <div className="text-sm text-slate-600">Bénéficiaire formation FLE</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="flex gap-1 text-orange-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <p className="text-slate-700 leading-relaxed italic">
                  "Un partenaire de confiance pour nos actions d'insertion. PULSAR FC fait un travail remarquable auprès des publics vulnérables. Leur approche humaine fait la différence."
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-slate-900 rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
                    JD
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">Jean Dupont</div>
                    <div className="text-sm text-slate-600">Responsable Mission Locale</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-slate-50 rounded-3xl p-8 space-y-6 hover:shadow-xl transition-all duration-300">
                <div className="flex gap-1 text-orange-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <p className="text-slate-700 leading-relaxed italic">
                  "Les formations proposées par PULSAR FC ont permis à nos salariés de mieux comprendre les enjeux de la diversité et de l'inclusion. Un accompagnement de qualité."
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
                    SM
                  </div>
                  <div>
                    <div className="font-bold text-slate-900">Sophie Martin</div>
                    <div className="text-sm text-slate-600">DRH Entreprise partenaire</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Territorial */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div className="space-y-8">
                <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 font-serif">Un ancrage territorial fort</h2>
                
                <p className="text-lg text-slate-600 leading-relaxed">
                  PULSAR FC s'inscrit dans une logique d'impact territorial en développant des partenariats locaux et en répondant aux besoins spécifiques de son territoire d'intervention.
                </p>
                
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-map-pin-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Proximité</h4>
                      <p className="text-slate-600">Des actions déployées au plus près des bénéficiaires, dans les quartiers prioritaires et les zones rurales.</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-links-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Coordination</h4>
                      <p className="text-slate-600">Une collaboration étroite avec les acteurs locaux pour éviter les doublons et maximiser l'efficacité.</p>
                    </div>
                  </div>
                  
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-line-chart-line text-2xl text-white"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-slate-900 mb-2">Évaluation</h4>
                      <p className="text-slate-600">Une mesure rigoureuse de notre impact social pour améliorer continuellement nos pratiques.</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/7c7cce6cfe9f9adcbefec9125a78f2c8.jpg"
                  alt="Impact territorial"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Devenir Partenaire */}
      <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold">Construisons ensemble une société plus inclusive</h2>
            <p className="text-xl text-slate-300 leading-relaxed">
              Vous êtes une collectivité, une entreprise, une association ou un organisme public et vous souhaitez vous engager à nos côtés ? Contactez-nous pour échanger sur les modalités de partenariat.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 pt-8">
              <div className="bg-slate-800 rounded-2xl p-6 space-y-3">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-hand-coin-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold">Soutien financier</h4>
                <p className="text-slate-300">Subventions, mécénat, financement de projets</p>
              </div>
              
              <div className="bg-slate-800 rounded-2xl p-6 space-y-3">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-team-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold">Partenariat opérationnel</h4>
                <p className="text-slate-300">Co-construction de projets, mise à disposition de ressources</p>
              </div>
              
              <div className="bg-slate-800 rounded-2xl p-6 space-y-3">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-briefcase-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold">Insertion professionnelle</h4>
                <p className="text-slate-300">Accueil de stagiaires, recrutement, parrainage</p>
              </div>
            </div>
            
            <div className="pt-8">
              <Link 
                to="/contact" 
                className="inline-block px-12 py-4 bg-orange-500 text-white rounded-full font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Devenir partenaire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
